var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeftIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3107 16L18.2803 22.7585C18.5732 23.0425 18.5732 23.503 18.2803 23.787C17.9874 24.071 17.5126 24.071 17.2197 23.787L9.71967 16.5143C9.42678 16.2302 9.42678 15.7698 9.71967 15.4857L17.2197 8.21301C17.5126 7.929 17.9874 7.929 18.2803 8.21301C18.5732 8.49703 18.5732 8.95752 18.2803 9.24153L11.3107 16Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeftIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChevronLeftIcon.0f431a84b29dde25f735e507881a03f6.svg";